import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import My from '@/components/my'
import homePage from '@/components/homePage'
import homePageDetail from '@/components/homePageDetail'
import message from '@/components/message'
import firstMessage from '@/components/firstMessage'
import position from '@/components/position'
import login from '@/components/login'
import jobWanted from '@/components/jobWanted'
import changePassWord from '@/components/changePassWord'//修改密码
import findWord from '@/components/findWord'//找回密码
import register from '@/components/register'//修改密码
import setPassWord from '@/components/setPassWord'//设置密码
import editResume from '@/components/editResume'//编辑简历
import log from '@/components/log'//登录
import writer from '@/components/writer.vue'//写一写
import open from '@/components/open.vue'//公开
import information from '@/components/information.vue'//个人信息
import editPersonal from '@/components/editPersonal.vue'//个人优势
import editWork from '@/components/editWork.vue'//编辑工作经历
import editEducation from '@/components/editEducation.vue'//编辑教育经历
import editProject from '@/components/editProject'//编辑项目经历
import addWork from '@/components/addWork'//添加教育经历
import addEducation from '@/components/addEducation'//添加教育经历
import addProject from '@/components/addProject'//添加教育经历
import detailsPosition from '@/components/detailsPosition'//职位详情
import jobWanteDetails from '@/components/jobWanteDetails'//求职期望详情
import addJobWanted from '@/components/addJobWanted'//添加求职期望
import sendResume from '@/components/sendResume'//简历上传
import firstMessageDetail from '@/components/firstMessageDetail'//添加求职期望
// 公司
import comMy from '@/components/company/comMy.vue'//公司我的
import comMessage from '@/components/company/comMessage.vue'//公司消息
import comPosition from '@/components/company/comPosition.vue'//公司职位
import comTalents from '@/components/company/comTalents.vue'//公司找人才
import comDetailsPosition from '@/components/company/comDetailsPosition.vue'//公司职位详情
import positionLeader from '@/components/company/positionLeader.vue'//职位leader
import remPosition from '@/components/company/remPosition.vue'//编辑职位
import releasePosition from '@/components/company/releasePosition.vue'//f发布职位
import comMyinfor from '@/components/company/comMyinfor.vue'//我的信息
import myCompany from '@/components/company/myCompany.vue'//我的公司
import comHomePage from '@/components/company/comHomePage.vue'//招人才
import Error404 from '@/components/company/Error404.vue'//提醒登录
import game from '@/components/company/game.vue'//我的信息
import comTalentsDtails from '@/components/company/comTalentsDtails.vue'//我的信息
import invitationPost from '@/components/company/invitationPost.vue'//我的信息
import comMessageDtails from '@/components/company/comMessageDtails.vue'//我的信息
import addkeyWord from '@/components/company/addkeyWord.vue'//我的信息
// import lianxi from '@/components/lianxi'//我的信息
// import error from '@/components/company/error.vue'//我的信息
// 商城
import home from '@/components/shop/home'//商城首页
import shopDetail from '@/components/shop/shopDetail'//商品详情
import shopCart from '@/components/shop/shopCart'//购物车
import orderPage from '@/components/shop/orderPage'//订单信息
import harvestAddress from '@/components/shop/harvestAddress.vue'//收货地址
import address from '@/components/shop/address.vue'//添加收货地址
import indexShop from '@/components/shop/indexShop.vue'//
import newShop from '@/components/shop/newShop.vue'//新购物车
import aaa from '@/components/shop/aaa.vue'//我的信息
import newAddress from '@/components/shop/newAddress.vue'//新增收货地址
import myShop from '@/components/shop/myShop.vue'//我i的
import allOrder from '@/components/shop/allOrder.vue'//订单列表
import allOrderDetail from '@/components/shop/allOrderDetail.vue'//订单详情
import search from '@/components/shop/search.vue'//搜索
import modifyAddress from '@/components/shop/modifyAddress.vue'//编辑地址
import pay from '@/components/shop/pay.vue'//支付
import orderPay from '@/components/shop/orderPay.vue'//订单支付
import classification from '@/components/shop/classification.vue'//分类
import newShopDetail from '@/components/shop/newShopDetail.vue'//商品详情
import homeClass from '@/components/shop/homeClass.vue'//分类
import cardRoll from '@/components/shop/cardRoll.vue'//红包卡卷
import buyCoupons from '@/components/shop/buyCoupons.vue'//红包卡卷
import activity from '@/components/shop/activity.vue'//中秋活动
import riceShop from '@/components/shop/riceShop.vue'//红包卡卷
import collageHome from '@/components/shop/collageHome.vue'//生成二维码
import collagePayHome from '@/components/shop/collagePayHome.vue'//订单生成二维码

Vue.use(Router)


const router=new Router({
  routes: [
    {
      path:'/',
      name:'home',
      component:home,
      meta:{
        title:'主页',
        tx:1
      }
      // component:(resolve)=> require(['/components/homePage.vue'].resolve)
    },

    {
      path: '/firstMessageDetail',
      name: 'firstMessageDetail',
      component:firstMessageDetail,
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld,
      meta:{
        title:'我的',
        index:4
      }
    },
    {
      path: '/game',
      name: 'game',
      component: game,

    },
    {
      path: '/homePageDetail',
      name: 'homePageDetail',
      component: homePageDetail,
      meta:{
        title:'动态详情',
        index:4
      }
    },
    {
      path: '/Error404',
      name: 'Error404',
      component: Error404,

    },
    {
      path:'/my',
      name:'my',
      component:My
    },

    {
      path: '/message',
      name: 'message',
      component: message,
      meta:{
        title:'消息',
        index:3
      }
    },
    {
      path: '/firstMessage',
      name: 'firstMessage',
      component: firstMessage,
      meta:{
        title:'消息',
        index:3
      }
    },
    {
      path: '/position',
      name: 'position',
      component: position,
      meta:{
        title:'职位',
        index:2
      }
    },
    {
      path: '/detailsPosition/:id/:cid',
      name: 'detailsPosition',
      component: detailsPosition,
      meta:{
        title:'职位详情',
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/jobWanted',
      name: 'jobWanted',
      component: jobWanted,
      meta:{
        title:'求职期望',
      }
    },
     {
       // path: '/jobWanteDetails/:id',
       path: '/jobWanteDetails',
       name: 'jobWanteDetails',
         component: jobWanteDetails,
       meta:{
       title:'求职期望',
     }
     },
    {
      path: '/addJobWanted',
      name: 'addJobWanted',
      component: addJobWanted,
      meta:{
        title:'求职期望',
      }
    },
    {
      path: '/changePassWord',
      name: 'changePassWord',
      component: changePassWord,
      meta:{
        title:'修改密码',
      }
    },
    {
      path: '/findWord',
      name: 'findWord',
      component: findWord,
      meta:{
        title:'找回密码',
      }
    },
    {
      path: '/setPassWord',
      name: 'setPassWord',
      component: setPassWord,
      meta:{
        title:'设置密码',
      }
    },
    {
      path: '/register',
      name: 'register',
        component: register,
      meta:{
      title:'注册',
    }
    },
    {
      path: '/editResume',
      name: 'editResume',
      component: editResume,
      meta:{
        title:'编辑简历',
      }
    },
    {
      path: '/log',
      name: 'log',
      component: log,
      meta:{
        title:'',
      }
    },
    {
      path: '/writer',
      name: 'writer',
      component: writer,
      meta:{
        title:'写一写',
      }
    },
    {
      path: '/open',
      name: 'open',
      component: open,
      meta:{
        title:'公开',
      }
    },
    {
      path: '/information',
      name: 'information',
      component: information,
      meta:{
        title:'个人信息',
      }
    },
    {
      path: '/editPersonal',
      name: 'editPersonal',
      component: editPersonal,
      meta:{
        title:'个人优势',
      }
    },
     {
       // path: '/editWork/:id',
       path: '/editWork/:id',
       name: 'editWork',
         component: editWork,
       meta:{
       title:'工作经历',
     }
     },
    {
      path: '/editEducation',
      name: 'editEducation',
      component: editEducation,
      meta:{
        title:'教育经历',
      }
    },
    {
      path: '/editProject/:id',
      name: 'editProject',
      component: editProject,
      meta:{
        title:'项目经历',
      }
    },
    {
      path: '/addWork/:id',
      name: 'addWork',
      component: addWork,
      meta:{
        title:'添加工作经历',
      }
    },
    {
      path: '/addEducation',
      name: 'addEducation',
      component: addEducation,
      meta:{
        title:'添加教育经历',
      }
    },
    {
      path: '/addProject',
      name: 'addProject',
      component: addProject,
      meta:{
        title:'添加项目经历',
      }
    },
    {
      path: '/sendResume',
      name: 'sendResume',
      component: sendResume,
      meta:{
        title:'上传简历',
      }
    },

// 公司
    {
      path: '/comMy',
      name: 'comMy',
      component: comMy,
      meta:{
        title:'公司我的',
      }
    },
    {
      path: '/comMessage',
      name: 'comMessage',
      component: comMessage,
      meta:{
        title:'公司消息',
      }
    },
    {
      path: '/comPosition',
      name: 'comPosition',
      component: comPosition,
      meta:{
        title:'公司职位',
      }
    },
    {
      path: '/comTalents',
      name: 'comTalents',
      component: comTalents,
      meta:{
        title:'找人才',
      }
    },
    {
      path: '/comDetailsPosition',
      name: 'comDetailsPosition',
        component: comDetailsPosition,
      meta:{
      title:'公司职位',
    }
    },
    {
      path: '/positionLeader',
      name: 'positionLeader',
      component: positionLeader,
      meta:{
        title:'职位leader',
      }
    },
    {
      path: '/remPosition',
      name: 'remPosition',
        component: remPosition,
      meta:{
      title:'编辑职位',
    }
    },
     {
       path: '/releasePosition',
       name: 'releasePosition',
         component: releasePosition,
       meta:{
       title:'发布职位',
     }
     },
      {
        path: '/comMyinfor',
        name: 'comMyinfor',
          component: comMyinfor,
        meta:{
        title:'个人信息',
      }
      },
    {
      path: '/myCompany',
      name: 'myCompany',
      component: myCompany,
      meta:{
        title:'我的公司',
      }
    },
    {
      path: '/comHomePage/:id',
      name: 'comHomePage',
      component: comHomePage,
      meta:{
        title:'公司主页',
      }
    },
    {
      path: '/comTalentsDtails',
      name: 'comTalentsDtails',
        component: comTalentsDtails,
      meta:{
      title:'招人详情',
    }
    },
    {
      path: '/invitationPost',
      name: 'invitationPost',
      component: invitationPost,
      meta:{
        title:'邀请投递',
      }
    },
    {
      path: '/comMessageDtails',
      name: 'comMessageDtails',
      component: comMessageDtails,
      meta:{
        title:'消息详情',
      }
    },
    {
      path: '/addkeyWord',
      name: 'addkeyWord',
      component: addkeyWord,
      meta:{
        title:'关键字',
      }
    },
/*  商城    */
    {
      path: '/home',
      name: 'home',
      component: home,
      meta:{
        title:'商城首页',
      }
    },
    {
      path: '/shopDetail',
      name: 'shopDetail',
        component: shopDetail,
      meta:{
        title:'商品详情',
      }
    },
    {
      path: '/shopCart',
      name: 'shopCart',
      component: shopCart,
      meta:{
        title:'商品详情',
      }
    },
    {
      path: '/orderPage',
      name: 'orderPage',
      component: orderPage,
      meta:{
        title:'订单详情',
      }
    },
    {
      path: '/harvestAddress',
      name: 'harvestAddress',
      component:harvestAddress,
      meta:{
        title:'收货地址',
      }
    },
    {
      path: '/address',
      name: 'address',
      component:address,
      meta:{
        title:'新建收货地址',
      }
    },
    {
      path: '/indexShop',
      name: 'indexShop',
      component:indexShop,
      meta:{
        title:'新建收货地址',
      }
    },
    {
      path: '/newShop',
      name: 'newShop',
      component:newShop,
      meta:{
        title:'购物车',
      }
    },
    {
      path: '/aaa',
      name: 'aaa',
      component:aaa,
      meta:{
        title:'新建收货地址',
      }
    },
    {
      path: '/newAddress',
      name: 'newAddress',
      component:newAddress,
      meta:{
        title:'新建收货地址',
      }
    },
    {
      path: '/myShop',
      name: 'myShop',
      component:myShop,
      meta:{
        title:'我的',
      }
    },
    {
      path: '/allOrder',
      name: 'allOrder',
      component:allOrder,
      meta:{
        title:'我的订单',
      }
    },
    {
      path: '/allOrderDetail',
      name: 'allOrderDetail',
      component:allOrderDetail,
      meta:{
        title:'我的订单详情',
      }
    },
    {
      path: '/search',
      name: 'search',
      component:search,
      meta:{
        title:'搜索',
      }
    },
    {
      path: '/modifyAddress',
      name: 'modifyAddress',
      component:modifyAddress,
      meta:{
        title:'地址详情',
      }
    },
    {
      path: '/pay',
      name: 'pay',
      component:pay,
      meta:{
        title:'支付',
      }
    },
     {
       path: '/orderPay',
       name: 'orderPay',
         component:orderPay,
       meta:{
       title:'订单管理订单支付',
      }
    },
    {
      path: '/classification',
      name: 'classification',
      component:classification,
      meta:{
        title:'分类',
      }
    },
    {
      path: '/newShopDetail',
      name: 'newShopDetail',
      component:newShopDetail,
      meta:{
        title:'新的商品详情',
      }
    },
    {
      path: '/homeClass',
      name: 'homeClass',
      component:homeClass,
      meta:{
        title:'分类',
      }
    },
    {
      path: '/cardRoll',
      name: 'cardRoll',
      component:cardRoll,
      meta:{
        title:'cardRoll',
      }
    },
     {
       path: '/buyCoupons',
         name: 'buyCoupons',
       component:buyCoupons,
       meta:{
       title:'购买优惠券',
     }
     },
    {
      path: '/activity',
      name: 'buyCoupons',
      component:activity,
      meta:{
        title:'活动',
      }
    },
    {
      path: '/riceShop',
      name: 'riceShop',
      component:riceShop,
      meta:{
        title:'粽子',
      }
    },
    {
      path: '/collageHome',
      name: 'collageHome',
      component:collageHome,
      meta:{
        title:'二维码',
      }
    },
    {
      path: '/collagePayHome',
      name: 'collagePayHome',
      component:collagePayHome,
      meta:{
        title:'二维码',
      }
    },
  ],
})

// router.beforeEach((to,from,next)=>{
//   if(localStorage.getItem("userid")){
//     // next({path:'/'})
//     next()
//     // _this.$router.push({ path:'/login'  })
//   }else {
//     if(to.path=='/login'){
//       next()
//     }else {
//       next({
//         path:'/login'
//       })
//     }
//   }
// })
// router.beforeEach((to, from, next) => {
//   if (localStorage.getItem('userid')) { // 如果已经登录的话
//     // next();
//     if (to.path === '/log'){
//       next({path: '/'})
//     }else {
//       next()
//     }
//   } else {
//     if (to.path === '/log') { // 如果是登录页面的话，直接next()
//       next();
//     }else if (to.path =='/register'){
//       next()
//     } else  { // 否则 跳转到登录页面
//       next({
//         path: '/log'
//       });
//     }
//   }
// });

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
router.beforeEach((to, from, next) => {
  if (localStorage.getItem('userid')) {
    // console.log(33)
    if (to.path === '/log') return next({path: '/home'})
    next()
  }else {
   if(['/log',"/",'/changePassWord','/findWord','/register','/position','/homePage','/newShopDetail'].indexOf(to.path)!==-1){
      next()

   }else {
     window.location.href="https://m.shangshebao.com/account/login.html?type=shop"
     // window.location.href="http://new.shangshebao.com/phone/shangshebao/account/login.html?type=shop"
     // if(to.path==='/Error404'){
     //   next()
     // }else {
     //   router.push("/Error404")
     // }
   }


  }
})
// Router.prototype.togo = function (path) {
//   this.isleft = true
//   this.isright = false
//   this.push(path)
// }
// // 需要右方向动画的路由用this.$router.goRight('****')
// Router.prototype.goRight = function (path) {
//   this.isright = true
//   this.isleft = false
//   this.push(path)
// }
// // 需要返回按钮动画的路由用this.$router.goBack()，返回上一个路由
// Router.prototype.goBack = function () {
//   this.isright = true
//   this.isleft = false
//   this.go(-1)
// }
// // 点击浏览器返回按钮执行，此时不需要路由回退
// Router.prototype.togoback = function () {
//   this.isright = true
//   this.isleft = false
// }
export default router



// WEBPACK FOOTER //
// ./src/router/index.js